import { Grid, Typography } from "@mui/material"
import styles from '../../../../Styles/ComponentStyles/ProfileStyle/AccValueTab.module.scss'
import CustomNumberTextField from "../../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField"
import { useContext, useEffect, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../../../Context/ProfileDetailsContext"

const TaxesTab = () => {
    const {
        finalData
    } = useContext(ProfileContext) as ProfileContextPayload

    const [taxTpAgeMin, setTaxTpAgeMin] = useState<number | null>(null);
    const [taxTpAgeMax, setTaxTpAgeMax] = useState<number | null>(null);
    const [taxIULAgeMin, setAccTpAgeMin] = useState<number | null>(null);
    const [taxIULAgeMax, setAccTpAgeMax] = useState<number | null>(null);

    const [changeYearTypical, setChangeYearTypical] = useState(finalData?.ageAtRetirement)
    const [changeYearIUL, setChangeYearIUL] = useState(finalData?.ageAtRetirement)

    const [taxTypicalAgeArray, setTaxTypicalAgeArray] = useState<number[]>([]);
    const [flagShowCalculationErrorTp, setCalculationShowErrorTp] = useState(false);

    useEffect(() => {
        if (finalData?.typical_plan?.TAXES_age_data && finalData?.iul_plan?.TAXES_age_data) {
            const taxTypicalAge = Object.keys(finalData.typical_plan.TAXES_age_data).map(Number);
            const taxIULAge = Object.keys(finalData?.iul_plan?.TAXES_age_data).map(Number);

            setTaxTypicalAgeArray(taxTypicalAge);

            setTaxTpAgeMin(taxTypicalAge[0]);
            setTaxTpAgeMax(taxTypicalAge[taxTypicalAge.length - 1]);
            setAccTpAgeMin(taxIULAge[0]);
            setAccTpAgeMax(taxIULAge[taxIULAge.length - 1]);
            setChangeYearTypical(taxTypicalAge[0]);
            setChangeYearIUL(taxIULAge[0]);
        }
    }, [finalData]);

    useEffect(() => {
        if (changeYearTypical == Number(taxTypicalAgeArray[taxTypicalAgeArray?.length - 1])) {
            setCalculationShowErrorTp(true)
        } else {
            setCalculationShowErrorTp(false)
        }
    }, [changeYearTypical])

    const inputChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(taxTpAgeMin) && val <= Number(taxTpAgeMax)) {
            setChangeYearTypical(val)
        }
        else {

            if (val >= Number(taxTpAgeMax))
                setChangeYearTypical(Number(taxTpAgeMax))
            else {
                setChangeYearTypical(Number(taxTpAgeMin))
            }
        }

    }

    const InputChangeYearIUL = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(taxIULAgeMin) && val <= Number(taxIULAgeMax)) {
            setChangeYearIUL(val)
        }
        else {

            if (val >= Number(taxIULAgeMax))
                setChangeYearIUL(Number(taxIULAgeMax))
            else {
                setChangeYearIUL(Number(taxIULAgeMin))
            }
            return;
        }
    }

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;
    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(taxTpAgeMin), Number(taxTpAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(taxTpAgeMax))
                setChangeYearTypical(Number(taxTpAgeMax))
            else {
                setChangeYearTypical(Number(taxTpAgeMin))
            }
            return
        }
    }

    const InputBlurChangeIUL = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(taxIULAgeMin), Number(taxIULAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(taxIULAgeMax))
                setChangeYearIUL(Number(taxIULAgeMax))
            else {
                setChangeYearIUL(Number(taxIULAgeMin))
            }
            return
        }
    }

    const formatNumber = (q: any) => {
        if (!q) return q;
        return q.toLocaleString('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: "usd"
        })
    }

    return (
        <>
            <Grid container className={styles.accValueTabWrapper}>
                {/* TYPICAL PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ borderRight: "1px solid #E2E8F0" }} className={flagShowCalculationErrorTp ? styles.accValueErrorStyleWrapper : undefined}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            Typical Plan
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Traditional Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>BASELINE</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                value={changeYearTypical}
                                                onChange={(e) => {
                                                    setChangeYearTypical(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: taxTpAgeMin, max: taxTpAgeMax } }}
                                                onBlur={inputBlureChangeYear}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        inputChangeYear(e);
                                                }}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container>
                                <Grid item className={styles.outputLabel} xs={10}>Age at Retirement</Grid>
                                <Grid item className={styles.outputValue} xs={2}>{finalData?.ageAtRetirement || "0"}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Starting Account Balance</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.currAccountBalance) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Contribution</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.yearly_contribution[changeYearTypical]) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={`${styles.fieldContainer} ${styles.accountSetupSectionForTaxes}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12} className={styles.sectionTitle}>
                                    Account Setup
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Tax Rate (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.typical_plan?.tax_rate_before_retirement || "0"}%
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Taxes Deferred</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.annual_tax_deferred) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Tax Deferred (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.TAXES_age_data[taxIULAgeMin ? taxIULAgeMin : ""]?.total_taxes_deferred) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Pre-Tax Income in Retirement</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.annual_pre_tax_income_in_retirement) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Spendable Income in Retirement</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.annual_spendable_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.totalTaxesPaidSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>
                                                Taxes Paid During Retirement
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={`${styles.totalValueContainer} ${finalData?.typical_plan?.TAXES_age_data[changeYearTypical]?.total_taxes_deferred < 0 ? styles.negativeBackground : ''}`}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Taxes Deferred (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.TAXES_age_data[changeYearTypical]?.total_taxes_deferred) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Rate</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.typical_plan?.TAXES_age_data[changeYearTypical]?.total_rate || "0"}%
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Income Tax Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.TAXES_age_data[changeYearTypical]?.annual_income_tax_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Income Tax Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.TAXES_age_data[changeYearTypical]?.total_income_tax_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {flagShowCalculationErrorTp &&
                                    <Grid item xs={12} className={styles.typicalValueEmptyTxt}>
                                        Typical plan account value is empty
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* IUL PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            IUL
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Alternative Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>COMPARISON</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                defaultValue={changeYearIUL}
                                                onChange={(e) => {
                                                    setChangeYearIUL(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: taxIULAgeMin, max: taxIULAgeMax } }}
                                                onBlur={InputBlurChangeIUL}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        InputChangeYearIUL(e);
                                                }}
                                                value={changeYearIUL}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container>
                                <Grid item className={styles.outputLabel} xs={10}>Age at Retirement</Grid>
                                <Grid item className={styles.outputValue} xs={2}>
                                    {finalData?.ageAtRetirement || "0"}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Premium</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.yearly_premium[changeYearIUL]) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Lump Sum Premium</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.lumpSumPremium) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={`${styles.fieldContainer} ${styles.accountSetupSectionForTaxes}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12} className={styles.sectionTitle}>
                                    Account Setup
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Tax Rate (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.iul_plan?.tax_rate_rpe_retirement || "0"}%
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Taxes Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.annual_taxes_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Tax Paid (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.total_taxes_paid_before_retirement) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Spendable Income in Retirement</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.total_account_value) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.totalTaxesPaidSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>
                                                Taxes Saved During Retirement
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Taxes Paid (Before Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.TAXES_age_data[changeYearIUL]?.total_taxes_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Rate</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.iul_plan?.TAXES_age_data[changeYearIUL]?.total_rate || "0"}%
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Income Tax Saved</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.TAXES_age_data[changeYearIUL]?.annual_income_tax_saved) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Income Tax Saved</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.TAXES_age_data[changeYearIUL]?.total_income_tax_saved) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Death Benefit</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.TAXES_age_data[changeYearIUL]?.total_death_benefit) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default TaxesTab
